import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {TaskModel} from "../../../tasks/models/task.model";

export class PlanningRouteActivitiesEditableTableCtrl implements IController {
  tasks: any;
  forcedStartTaskIds: any;
  forcedEndTaskIds: any;
  routeAnalysis: any;
  highlightedTaskId: any;
  selectedIds: any;
  queryString: any;
  isEditable: any;
  onHighlightedTaskSelect: Function;
  onToggleTask: Function;
  onToggleSelectAll: Function;
  onRemove: Function;
  onEditBoundEquipment: Function;
  onChange: Function;
  onToggleForcedStartTasks: Function;
  onToggleForcedEndTasks: Function;

  public selectedKeys: any = {};
  public dropableKeys: any = {};
  public hasPermissionToEdit: any = undefined;
  public treeOptions: any = {};
  public forcedStartTaskKeys: any;
  public forcedEndTaskKeys: any;
  public displayAsItems: any;


  constructor(private IAMPermissions, private tasksService: TasksService, private $mdMedia) {
  }

  $onInit() {
    this.hasPermissionToEdit = this.IAMPermissions.hasPermission('planning.routes.update');

    this.treeOptions = {
      dragStart: (event) => {
        this.dropableKeys = {};
        const draggedTaskItem = event.source.nodeScope.$modelValue,
          hasTaskStarted = this._hasTaskStarted(draggedTaskItem),
          serviceIds = draggedTaskItem.bundleServiceIdList
            ? draggedTaskItem.bundleServiceIdList
            : [draggedTaskItem.serviceId],
          isBundle = draggedTaskItem.numberOfTasks > 2,
          complementaryTaskIndex = _.findIndex(this.tasks,
            (task: TaskModel) => {
              if (_.isEqual(task.id, draggedTaskItem.id)) {
                return false
              } else {
                if (task.bundleServiceIdList) {
                  const isRequestedPositionTaskComplementary = this.tasksService.complementaryServiceIdsTest(task.bundleServiceIdList, serviceIds);
                  return !!isRequestedPositionTaskComplementary;

                  // serviceIndexInBundle = _.indexOf(task.bundleServiceIdList, serviceIds[0]);
                  // return serviceIndexInBundle !== -1;
                } else {
                  const serviceIdIndex = _.indexOf(serviceIds, task.serviceId);
                  return serviceIdIndex !== -1;
                }
              }
            }),
          isComplementaryTaskExists = complementaryTaskIndex !== -1;

        if (_.isEqual(draggedTaskItem.status, 'CourierDeparted')) {
          return;
        }
        if (isBundle && draggedTaskItem.taskSpec.purpose === 'Pickup') {
          _.forEach(this.tasks, (task: TaskModel) => {
            this.dropableKeys[task.id] = false;
          });
          return;
        }


        if (isBundle && draggedTaskItem.taskSpec.purpose === 'Dropoff') {
          _.forEach(this.tasks, (task: TaskModel) => {
            let bundleSameDeliveries = [];

            if (task.taskType === "BundledStopover"
              && task.taskSpec.purpose === 'Pickup') {
              bundleSameDeliveries = _.filter(
                task.bundleServiceIdList,
                function (serviceId) {
                  return _.indexOf(
                    draggedTaskItem.bundleServiceIdList,
                    serviceId) !== -1;
                })
            }
            this.dropableKeys[task.id] = !bundleSameDeliveries.length;
            // this.dropableKeys[task.id] = !(task.taskType === "BundledStopover" && task.taskSpec.purpose === 'Pickup');
          });
          return;
        }


        // If dragged task item is heading/arrived (accept tasks position for ONLY Heading/Arrived)
        if (hasTaskStarted) {
          _.forEach(this.tasks, (task: TaskModel) => {
            this.dropableKeys[task.id] = this._hasTaskStarted(task);
          });
          return;
        }

        // If there is no complementary Task (accept all positions)
        if (!isComplementaryTaskExists) {
          _.forEach(this.tasks, (task: TaskModel) => {
            this.dropableKeys[task.id] = !this._hasTaskStarted(task);
          });
          return;
        }

        //Pickup Task - positions Handle
        if (_.isEqual(draggedTaskItem.taskSpec.purpose, 'Pickup')) {
          _.forEach(this.tasks, (task: TaskModel, index: any) => {
            this.dropableKeys[task.id] = index < complementaryTaskIndex && !this._hasTaskStarted(task);
          });
        } else if (_.isEqual(draggedTaskItem.taskSpec.purpose, 'Dropoff')) {
          _.forEach(this.tasks, (task: TaskModel, index: any) => {
            this.dropableKeys[task.id] = index > complementaryTaskIndex && !this._hasTaskStarted(task);
          });
        } else {
          _.forEach(this.tasks, (task: TaskModel, index: any) => {
            this.dropableKeys[task.id] = !this._hasTaskStarted(task);
          });
        }

        // Set drop options by forced start tasks
        if (!_.includes(this.forcedStartTaskIds, draggedTaskItem.id)) {
          _.forEach(this.forcedStartTaskIds, (forcedId) => {
            this.dropableKeys[forcedId] = false;
          });
        } else {
          // _.forEach(this.tasks, (task) => {
          //   if (!_.includes(this.forcedStartTaskIds, task.id)) {
          //     this.dropableKeys[task.id] = false;
          //   }
          // });
        }


        // Set drop options by forced end tasks
        if (!_.includes(this.forcedEndTaskIds, draggedTaskItem.id)) {
          _.forEach(this.forcedEndTaskIds, (forcedId) => {
            this.dropableKeys[forcedId] = false;
          });
        } else {
          // _.forEach(this.tasks, (task) => {
          //   if (!_.includes(this.forcedEndTaskIds, task.id)) {
          //     this.dropableKeys[task.id] = false;
          //   }
          // });
        }

      },
      accept: (sourceNodeScope, destinationNodesScope, destinationIndex) => {
        const destinationTaskId = this.tasks[destinationIndex].id;
        return this.dropableKeys[destinationTaskId];
      },
      beforeDrop: (event) => {
        const destinationTaskId = this.tasks[event.dest.index].id;
        return this.dropableKeys[destinationTaskId];
      },
      dropped: (event) => {
        const taskId = event.source.nodeScope.$modelValue.id,
          previousIndex = event.source.index,
          currentIndex = event.dest.index,
          taskIdsOrder = _.map(this.tasks, function (task: TaskModel) {
            return task.id
          });

        if (!_.isEqual(currentIndex, previousIndex)) {
          taskIdsOrder.splice(previousIndex, 1);
          taskIdsOrder.splice(currentIndex, 0, taskId);

          this.onChange({taskIdsOrder: taskIdsOrder});
        }

      }
    };
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (selectedId) => {
        this.selectedKeys[selectedId] = true;
      })
    }
    if (changes.forcedStartTaskIds) {
      this.forcedStartTaskKeys = [];

      _.forEach(this.forcedStartTaskIds, (forcedId) => {
        this.forcedStartTaskKeys[forcedId] = true;
      })

      // adding relevant bundles
      const forcedStartBundleIds = _.chain(this.tasks)
        .filter((task: TaskModel) => {
          return task.taskType === 'BundledStopover' &&
            _.difference(task.taskIdList, this.forcedStartTaskIds).length < task.taskIdList.length;
        })
        .map('id')
        .value();

      _.forEach(forcedStartBundleIds, (bundleId) => {
        this.forcedStartTaskKeys[bundleId] = true;
      })

    }
    if (changes.forcedEndTaskIds) {
      this.forcedEndTaskKeys = [];

      _.forEach(this.forcedEndTaskIds, (forcedId) => {
        this.forcedEndTaskKeys[forcedId] = true;
      })

      // adding relevant bundles
      const forcedEndBundleIds = _.chain(this.tasks)
        .filter((task: TaskModel) => {
          return task.taskType === 'BundledStopover' &&
            _.difference(task.taskIdList, this.forcedEndTaskIds).length < task.taskIdList.length;
        })
        .map('id')
        .value();

      _.forEach(forcedEndBundleIds, (bundleId) => {
        this.forcedEndTaskKeys[bundleId] = true;
      })

    }
  };

  $doCheck() {
    this.displayAsItems = !this.$mdMedia('gt-xs');
  };

  /////////////////////////////////////////////////////////////////////////////

  // ******************************
  //        Public methods
  // ******************************

  getCanEditValue() {
    return this.hasPermissionToEdit;
  }

  // ******************************
  //        Private methods
  // ******************************

  private _hasTaskStarted(task: TaskModel) {
    return _.isEqual(task.status, 'CourierHeading') ||
      _.isEqual(task.status, 'CourierArrived') ||
      _.isEqual(task.status, 'CourierDeparted');
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningRouteActivitiesEditableTable', {
    bindings: {
      tasks: '<',
      forcedStartTaskIds: '<',
      forcedEndTaskIds: '<',
      routeAnalysis: '<',
      highlightedTaskId: '<',
      selectedIds: '<',
      queryString: '<',
      isEditable: '<',
      onHighlightedTaskSelect: '&',
      onToggleTask: '&',
      onToggleSelectAll: '&',
      onRemove: '&',
      onEditBoundEquipment: '&',
      onChange: '&',
      onToggleForcedStartTasks: '&',
      onToggleForcedEndTasks: '&'
    },
    template: require('./planning-route-activities-editable-table.html').default,
    controller: PlanningRouteActivitiesEditableTableCtrl
  });
